// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__3moR8","small":"Link_small__2RiLI"};